//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  resource,
  signal,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

// local imports
import { CatalogConstants, CatalogStateService, DocumentModel } from "@app/catalog";
import { CatalogCommonConstants } from "@app/catalog-common";

@Component({
  selector: "program-property",
  standalone: false,
  templateUrl: "./program-property.component.html",
  styleUrl: "./program-property.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramPropertyComponent {
  private route = inject(ActivatedRoute);
  private catalogStateService = inject(CatalogStateService);


  public programPropertyResource = resource({
    request: () => ({
      id: this.route.snapshot.paramMap.get("id"),
      departmentId: this.route.snapshot.queryParamMap.get(
        CatalogCommonConstants.ROUTE_PARAMS.DEPARTMENT_ID
      ),
    }),
    loader: async ({ request }) => {
      const property = await this.catalogStateService.getProgramProperty(
        request.id
      );

      if (property.documents) {
        const filteredDocuments = property.documents().filter(
          (doc: DocumentModel) => !doc.superseded()
        );
        property.documents.set(filteredDocuments);
      }

      return property;
    },
  });
  
}